/**
 * ═══════════════════════════════════════════════════════════════
 *  CONFIGURACIÓN DE PAGOS — edita estos valores con los tuyos
 * ═══════════════════════════════════════════════════════════════
 *
 *  WOMPI:
 *    1. Crea tu cuenta en https://comercios.wompi.co
 *    2. Ve a "Enlaces de pago" → crea uno por el valor del plan
 *    3. Copia el enlace (formato https://checkout.wompi.co/l/xxxxx)
 *    4. Pégalo abajo en wompiCheckoutUrl
 *
 *  MERCADOPAGO:
 *    1. Crea tu cuenta en https://www.mercadopago.com.co
 *    2. Ve a "Herramientas" → "Enlaces de pago" → crea uno
 *    3. Copia el enlace (formato https://mpago.la/xxxxx)
 *    4. Pégalo abajo en mercadoPagoCheckoutUrl
 *
 *  El cliente paga → te llega la notificación del banco →
 *  activas su plan desde el panel SuperAdmin (sección Solicitudes).
 */
export const PAYMENT_CONFIG = {
  /** Enlace de pago de Wompi para la suscripción mensual */
  wompiCheckoutUrl: 'https://checkout.wompi.co/l/VPOS_zgiHyu',

  /** Enlace de pago de MercadoPago para la suscripción mensual */
  mercadoPagoCheckoutUrl: 'https://link.mercadopago.com.co/safeskids',

  /** WhatsApp de soporte: código de país + número, SIN espacios ni signos */
  whatsappNumber: '573172247757',

  /** Email de soporte */
  adminEmail: 'webmaster.tesos@outlook.com',
}

// Normaliza enlaces de pago: RTDB a veces guarda dominios sin esquema
// ("link.mercadopago.com.co/...") y window.open() los trataría como ruta
// relativa (pago roto). Siempre devuelve URL absoluta https://.
export function normalizeUrl(url: string): string {
  const u = (url ?? '').trim()
  if (!u) return u
  if (/^https?:\/\//i.test(u)) return u
  return `https://${u}`
}

export function whatsappContactUrl(message: string, overrideNumber?: string): string {
  const num = (overrideNumber ?? '').trim() || PAYMENT_CONFIG.whatsappNumber
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`
}

export function isPaymentConfigured(): boolean {
  return (
    !PAYMENT_CONFIG.wompiCheckoutUrl.includes('TU_LINK_WOMPI') ||
    !PAYMENT_CONFIG.mercadoPagoCheckoutUrl.includes('TU_LINK_MERCADOPAGO')
  )
}